var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "import-modal",
      attrs: { size: "large" },
      on: { close: _vm.cancelImport }
    },
    [
      _c("h2", { staticClass: "import-modal__title" }, [
        _vm._v(
          "\n\t\t" + _vm._s(_vm.$t("calendar", "Import calendars")) + "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "import-modal__subtitle" }, [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.$t("calendar", "Please select a calendar to import into …")
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        { staticClass: "import-modal__file-list", attrs: { tag: "ul" } },
        [
          _c(
            "li",
            {
              key: _vm.headerRowKey,
              staticClass:
                "import-modal-file-item import-modal-file-item--header"
            },
            [
              _c("div", { staticClass: "import-modal-file-item__filename" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Filename")) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "import-modal-file-item__calendar-select" },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("calendar", "Calendar to import into")) +
                      "\n\t\t\t"
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.files, function(file, index) {
            return _c("ImportScreenRow", {
              key: "import-file-" + index,
              attrs: { file: file }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "import-modal__actions" }, [
        _c("button", { on: { click: _vm.cancelImport } }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.$t("calendar", "Cancel")) + "\n\t\t")
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "primary", on: { click: _vm.importCalendar } },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$n(
                    "calendar",
                    "Import calendar",
                    "Import calendars",
                    _vm.files.length
                  )
                ) +
                "\n\t\t"
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }